import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <undefined><div>
        <h3 parentName="div" {...{
          "className": "specialstyling mt-6",
          "id": "international-glyt"
        }}><span parentName="h3" {...{
            "className": "category"
          }}>{`EUROPEAN CONGRESS ON EVANGELISM`}</span></h3>
        <h4 parentName="div">{`EQUIPPING EVANGELISTS IN EUROPE`}</h4>
        <p parentName="div">{` As I write this, `}<strong parentName="p">{`I’m preparing to join my father, Franklin Graham, in Berlin for the much-anticipated European Congress on Evangelism, which will take place May 27–30.`}</strong>{` We prayerfully believe that—with God’s providence and blessing—this gathering of 1,000 leaders from 57 European countries and territories has the potential to alter the eternities of millions across the continent.`}</p>
        <div parentName="div" {...{
          "className": "berlin image-float-right"
        }}>
          <span parentName="div" {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "900px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "146.00000000000003%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAAdABQDASIAAhEBAxEB/8QAGQAAAwADAAAAAAAAAAAAAAAAAAEEAgMF/8QAFgEBAQEAAAAAAAAAAAAAAAAAAAEC/9oADAMBAAIQAxAAAAHrS3zzVYy50jUMyD//xAAbEAACAgMBAAAAAAAAAAAAAAABAgARAxIhEP/aAAgBAQABBQLJk0Zc1AdDLZRb87LM7ColCaLP/8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQMBAT8BI//EABQRAQAAAAAAAAAAAAAAAAAAACD/2gAIAQIBAT8BH//EAB4QAAIBBAMBAAAAAAAAAAAAAAABMQIQEUESMlFy/9oACAEBAAY/AksN58K3xq7eWyV/Tts2SyCCD//EABwQAAMAAgMBAAAAAAAAAAAAAAABETFBIWHwgf/aAAgBAQABPyF6PrFGbhZ4IaDkq2QE+8ZHQxuglEktF8o8YeSQrOJDCHRP/9oADAMBAAIAAwAAABC/AMP/xAAYEQADAQEAAAAAAAAAAAAAAAAAASEQEf/aAAgBAwEBPxBlzIQ//8QAFREBAQAAAAAAAAAAAAAAAAAAASD/2gAIAQIBAT8QY//EAB8QAQACAgEFAQAAAAAAAAAAAAERIQBBMVFhcYHw8f/aAAgBAQABPxCIKFVV674OH3vBVN14y90BgWecZACECFNE6wMmcwpVWnnCrQIDI4tR0MHp9rc5bgMIMKQ8n3XOcOa39vPzc//Z')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "congresslogo",
              "title": "congresslogo",
              "src": "/static/bc1d4c6908e6a939e1bf6469d8200f2d/8e1fc/congresslogo.jpg",
              "srcSet": ["/static/bc1d4c6908e6a939e1bf6469d8200f2d/f93b5/congresslogo.jpg 300w", "/static/bc1d4c6908e6a939e1bf6469d8200f2d/b4294/congresslogo.jpg 600w", "/static/bc1d4c6908e6a939e1bf6469d8200f2d/8e1fc/congresslogo.jpg 900w"],
              "sizes": "(max-width: 900px) 100vw, 900px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </div>
        <p parentName="div">{` For years, faith in Europe has been in steep decline. Many still refer to themselves as Christians, but they do not practice their faith. Instead, most embrace the world’s way of thinking over the truth of God’s Word. Sadly, in many situations, it’s so-called churches that are pushing the most anti-Biblical social policies. `}</p>
        <p parentName="div">{` `}<strong parentName="p">{`Given this parched spiritual climate, it’s vitally important that we once again equip and encourage pastors, evangelists, and other leaders who are `}<em parentName="strong">{`“proclaiming the kingdom of God and teaching about the Lord Jesus Christ with all boldness”`}</em>{` (Acts 28:31, ESV) on the front lines of ministry across Europe.`}</strong>{` Some of these men and women have been attacked, vilified, and even arrested for fearlessly proclaiming Scripture. They need to be built up and supported as they continue faithfully in their calling.`}</p>
        <p parentName="div">{` Please be in prayer for this monumental event, which is taking place exactly a quarter-century after my grandfather last held a massive gathering of evangelists at the Amsterdam 2000 conference. Would you personally “adopt” one country in Europe as your prayer focus in the coming weeks? As a chorus of worldwide believers, let’s carry these dear brothers and sisters to our Heavenly Father, and pray for His protection, blessing, and favor on each of them.`}</p>
        <h3 parentName="div" {...{
          "className": "specialstyling mt-6",
          "id": "evangelistic-crusades"
        }}><span parentName="h3" {...{
            "className": "category"
          }}>{`INTERNATIONAL GOD LOVES YOU TOUR`}</span></h3>
        <h4 parentName="div">{`SHARING GOD’S LOVE IN LONDON`}</h4>
        <p parentName="div">{` Just a couple of weeks after the European Congress on Evangelism, my father `}<strong parentName="p">{`will preach the Good News in London, England, for the God Loves You Tour at ExCeL London on June 21.`}</strong></p>
        <span parentName="div" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "960px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "66.66666666666666%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAgX/xAAWAQEBAQAAAAAAAAAAAAAAAAAAAQL/2gAMAwEAAhADEAAAAVJqrNaggH//xAAaEAEAAwADAAAAAAAAAAAAAAABAAIDEiIx/9oACAEBAAEFAs+p6lwNCcmN0f/EABURAQEAAAAAAAAAAAAAAAAAAAAh/9oACAEDAQE/AUf/xAAUEQEAAAAAAAAAAAAAAAAAAAAQ/9oACAECAQE/AT//xAAaEAACAgMAAAAAAAAAAAAAAAAAEQECEDJh/9oACAEBAAY/AkM1gr2HhH//xAAcEAEAAgIDAQAAAAAAAAAAAAABABEhMUFRcYH/2gAIAQEAAT8hTYBmLTd8VME+5KtnczEAfdzEg13P/9oADAMBAAIAAwAAABC4L//EABYRAQEBAAAAAAAAAAAAAAAAAAABMf/aAAgBAwEBPxDFp//EABYRAQEBAAAAAAAAAAAAAAAAABEAAf/aAAgBAgEBPxBY2//EABwQAQADAAIDAAAAAAAAAAAAAAEAETEhQWGh8f/aAAgBAQABPxA7RW872ClQC4EIFLw3BaXKzA0vEBzbY7Z9iAi42Lfc/9k=')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "wg stage",
            "title": "wg stage",
            "src": "/static/b4c8a6d8c5258533a3afefd234a872f9/6a068/wg-stage.jpg",
            "srcSet": ["/static/b4c8a6d8c5258533a3afefd234a872f9/f93b5/wg-stage.jpg 300w", "/static/b4c8a6d8c5258533a3afefd234a872f9/b4294/wg-stage.jpg 600w", "/static/b4c8a6d8c5258533a3afefd234a872f9/6a068/wg-stage.jpg 960w"],
            "sizes": "(max-width: 960px) 100vw, 960px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
        <figcaption parentName="div"><strong parentName="figcaption">{`THOUSANDS HAVE HEARD THE GOSPEL`}</strong>{` in the United Kingdom during God Loves You Tour events over the past few years—but the spiritual need is still great.`}</figcaption>
        <p parentName="div">{` Will you join me in praying now for the believers in and around London? Pray that they will be bold in the face of a hostile culture, that they will invite and bring their family and friends to the God Loves You Tour, and that many people far from the Lord will come to know `}<em parentName="p">{`“the gift of God … eternal life in Christ Jesus our Lord”`}</em>{` (Romans 6:23, NKJV).`}</p>
        <span parentName="div" {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1200px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.66666666666667%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/jpeg;base64,/9j/2wBDABALDA4MChAODQ4SERATGCgaGBYWGDEjJR0oOjM9PDkzODdASFxOQERXRTc4UG1RV19iZ2hnPk1xeXBkeFxlZ2P/2wBDARESEhgVGC8aGi9jQjhCY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2NjY2P/wgARCAANABQDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABAAD/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAH/2gAMAwEAAhADEAAAAVm2EaxJP//EABoQAAIDAQEAAAAAAAAAAAAAAAECAAMSERT/2gAIAQEAAQUC6xll7IfSYXlh02jP/8QAFREBAQAAAAAAAAAAAAAAAAAAABH/2gAIAQMBAT8BR//EABURAQEAAAAAAAAAAAAAAAAAAAAR/9oACAECAQE/Aar/xAAZEAACAwEAAAAAAAAAAAAAAAAAARARMkH/2gAIAQEABj8C0UzsK4//xAAaEAACAwEBAAAAAAAAAAAAAAAAAREhUUFx/9oACAEBAAE/IeVqxHREChuXiGFRajKj/9oADAMBAAIAAwAAABDk/wD/xAAWEQEBAQAAAAAAAAAAAAAAAAABEBH/2gAIAQMBAT8QQyP/xAAVEQEBAAAAAAAAAAAAAAAAAAABEP/aAAgBAgEBPxAQx//EABsQAQACAwEBAAAAAAAAAAAAAAEAESExUZGh/9oACAEBAAE/EEy8rStfYSqTa0wzUE7QQ44lwBx6E1aDFE//2Q==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "rrt tornado 2",
            "title": "rrt tornado 2",
            "src": "/static/6f1583bdaeebdf6c070856b716b28da3/e5166/rrt-tornado-2.jpg",
            "srcSet": ["/static/6f1583bdaeebdf6c070856b716b28da3/f93b5/rrt-tornado-2.jpg 300w", "/static/6f1583bdaeebdf6c070856b716b28da3/b4294/rrt-tornado-2.jpg 600w", "/static/6f1583bdaeebdf6c070856b716b28da3/e5166/rrt-tornado-2.jpg 1200w", "/static/6f1583bdaeebdf6c070856b716b28da3/d9c39/rrt-tornado-2.jpg 1800w", "/static/6f1583bdaeebdf6c070856b716b28da3/df51d/rrt-tornado-2.jpg 2400w"],
            "sizes": "(max-width: 1200px) 100vw, 1200px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy",
            "decoding": "async"
          }}></img>{`
    `}</span>
        <figcaption parentName="div"><strong parentName="figcaption">{`CHAPLAINS MINISTER`}</strong>{` in southeast Missouri following devastating tornadoes.`}</figcaption>
        <h3 parentName="div" {...{
          "className": "specialstyling mt-6",
          "id": "billy-graham-rrt"
        }}><span parentName="h3" {...{
            "className": "category"
          }}>{`BILLY GRAHAM RAPID RESPONSE TEAM`}</span></h3>
        <h4 parentName="div">{`THE HOPE OF GOD IN THE MIDST OF CRISIS`}</h4>
        <p parentName="div">{` Here at home, life has been extremely difficult for many around us as tornadoes, flooding, and fires have destroyed homes and businesses. `}</p>
        <p parentName="div">{` Time and time again, crisis-trained chaplains with the Billy Graham Rapid Response Team have deployed into these areas of intense heartache with the `}<em parentName="p">{`“light of the gospel”`}</em>{` (2 Corinthians 4:4, NKJV).`}</p>
        <p parentName="div">{` `}<strong parentName="p">{`The chaplains recently concluded their ministry in southeast Missouri`}</strong>{`, where they met the emotional and spiritual needs of more than 1,000 people following a tornado that devastated the area in mid-March. As is often the case, they found that many of the survivors had been through storms in their personal lives long before the tornado tore through their town.`}</p>
        <p parentName="div">{` A 57-year-old man named Donald* was already battling Stage 4 cancer before the tornado split his home in two. Donald was overwhelmed and devastated. The chaplains sat with him and his wife and had a lengthy conversation about the freedom found through a relationship with the Lord. Eventually the couple began to understand that salvation is not based on our works but on Christ’s sacrifice alone. They were excited to pray in repentance, placing their faith in the person of Jesus. In the midst of a hopeless situation, with many dark days ahead, `}<strong parentName="p">{`Donald and his wife now have the light of the Lord living within them and the strength to move forward in His grace.`}</strong></p>
        <p parentName="div">{` Will you join me in praying for them and all of those who have placed their faith in Christ following recent tragedies? Thank you for your support of the Billy Graham Rapid Response Team as they carry the hope of the Gospel into these difficult situations.`}</p>
        <h4 parentName="div">{`THE WORD WILL NOT RETURN VOID`}</h4>
        <p parentName="div">{` My friends, God promises this: `}<em parentName="p">{`“So shall My word be that goes forth from My mouth; it shall not return to Me void, but it shall accomplish what I please”`}</em>{` (Isaiah 55:11, NKJV). These are difficult times, but we will continue to proclaim the Good News, knowing that His Word will transform lives around the world. `}<strong parentName="p">{`Thank you for your partnership in these efforts. Eternity is at stake, and it’s being impacted by your prayers and support.`}</strong></p>
        <div parentName="div" {...{
          "className": "image-float-right"
        }}>
          <p parentName="div">{`Blessings,`}</p>
          <img parentName="div" {...{
            "className": "signature",
            "src": "https://static.billygraham.org/sites/billygraham.org/uploads/prod/2022/02/Will-Graham-Signature.png",
            "alt": ""
          }}></img>
          <p parentName="div">{`Will Graham`}<br parentName="p"></br>{`Executive Vice President`}</p>
        </div>
        <br parentName="div"></br>
        <div parentName="div" {...{
          "style": {
            "clear": "both"
          }
        }}>
          <br parentName="div"></br>
          <p parentName="div">{`*Names and photos changed to protect privacy`}</p>
        </div>
      </div>
      <hr></hr>
      <div {...{
        "className": "give-background"
      }}>
        <h4 parentName="div" {...{
          "className": "cta projects"
        }}>{`YOU CAN MAKE A DIFFERENCE`}</h4>
        <h4 parentName="div" {...{
          "className": "smaller"
        }}>{`
GOD WORKS THROUGH PEOPLE LIKE YOU TO CHANGE THE WORLD BY THE POWER OF THE
GOSPEL.
`}</h4>
        <p parentName="div">{`
`}<span parentName="p" {...{
            "className": "options"
          }}>{`WHERE MOST NEEDED`}</span>{` | The Gospel changes lives—now and for eternity. When you designate a gift for “`}<strong parentName="p">{`Where Most Needed`}</strong>{`,” it is available for immediate ministry opportunities and needs, including the personnel, resources, materials, equipment, and support services vital to the work of evangelism around the world.`}</p>
        <p parentName="div">{`
`}<span parentName="p" {...{
            "className": "options"
          }}>{`GOOD NEWS TOUR WITH WILL GRAHAM`}</span>{` | Later this year, Will Graham is going to proclaim the Gospel of Jesus Christ in four cities across Florida. Friends like you are vital to making this evangelistic outreach possible. Your support will help people far from God hear about His love for them during the `}<strong parentName="p">{`Sunshine State Good News Tour.`}</strong></p>
        <p parentName="div">{`
`}<span parentName="p" {...{
            "className": "options"
          }}>{`EUROPEAN CONGRESS ON EVANGELISM`}</span>{` | You can help equip Christian leaders in Europe to boldly proclaim the Gospel. The Billy Graham Evangelistic Association is convening the `}<strong parentName="p">{`European Congress on Evangelism`}</strong>{` (ECE) in Berlin to encourage believers from 57 countries and territories in sharing God’s truth in their communities. Your gift will help send these leaders to the ECE and reach people all over Europe with the Good News.`}</p>
        <p parentName="div">{`
`}<span parentName="p" {...{
            "className": "options"
          }}>{`INTERNATIONAL GOD LOVES YOU TOUR`}</span>{` | Through your gift for the `}<strong parentName="p">{`International God Loves You Tour`}</strong>{`, you can help share the life-changing power of His Gospel with individuals in cities around the world, including London, England, this June.`}</p>
      </div></undefined>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      